import React from 'react'
import { Category } from 'lib/types'
import { ProductListLayout } from 'lib/modules/catalog'

interface Props {
  category: Category
}

export const CategoryScene = ({ category }: Props) => {
  const { id, name, image } = category

  return (
    <ProductListLayout
      title={name}
      categoryId={id}
      banner={!image ? undefined : (
        <p>
          <img src={image} alt='' />
        </p>
      )}
    />
  )
}
